import { useEffect } from 'react'
import { Link } from 'react-router'
import { useSessione } from '../../servizi/sessione.tsx'
import { Intestazione } from '../../componenti/Pezzi.tsx'
import { Riquadro } from '../../componenti/base.tsx'
import { capitoliPer, visibile } from '../../guida/indice.ts'
import { ULTIMA, VERSIONI } from '../../guida/novita.ts'
import { segnaVista } from '../../guida/vista.ts'
import { Testo } from './pezzi.tsx'

/**
 * Novità per versione, dalla più recente (guida/novita.ts). Ognuno legge le cose che riguardano i
 * suoi incarichi; aprire la pagina vale come lettura, e l'avviso delle novità non ricompare.
 */
export function Novita() {
  const { io, puo } = useSessione()
  const capitoli = new Set(capitoliPer(puo).map((c) => c.id))

  useEffect(() => { if (io) segnaVista(io.id, ULTIMA.numero) }, [io])

  return (
    <>
      <Intestazione
        titolo="Novità"
        sottotitolo="Che cosa è cambiato nel gestionale, versione per versione. Trovi le cose che riguardano i tuoi incarichi."
        azioni={<Link className="bottone bottone-secondario" to="/guida">Guida</Link>}
      />
      {VERSIONI.map((v) => {
        const voci = v.cambiamenti.filter((c) => visibile(c.permesso, puo))
        return (
          <Riquadro key={v.numero} titolo={`Versione ${v.numero} · ${v.data}`}>
            {voci.length ? (
              <ul className="guida-novita">
                {voci.map((c) => (
                  <li key={c.testo}>
                    <Testo t={c.testo} />
                    {c.capitolo && capitoli.has(c.capitolo) && (
                      <> <Link to={`/guida/${c.capitolo}`} className="piccolo">Nella guida</Link></>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="tenue">Niente di nuovo per i tuoi incarichi.</p>
            )}
          </Riquadro>
        )
      })}
    </>
  )
}
